module.exports = __webpack_public_path__ + "static/media/cimitero.a207a294.png";